import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { NotFoundComponent } from '../security/not-found/not-found.component';
import { InvalidRequestComponent } from '../security/invalid-request/invalidrequest.component';
import { PermissionResponse } from '../core/base-api';
import { AppFormatConfigService } from '../core/services/app-format-config.service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const DashboardRoutes: Routes = [
  {
    path: 'home',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => routes
      },
      {
        path: 'notfound',
        component: NotFoundComponent
      },
      {
        path: 'invalidrequest',
        component: InvalidRequestComponent
      }
    ],
    providers: [AppFormatConfigService]
  }
];

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: '..',
    component: DashboardComponent
  }
];
